import ValueObject from './ValueObject';

export default class SegmentId extends ValueObject {
  equals(other) {
    if (!(other instanceof SegmentId)) {
      return false;
    }

    return super.equals(other);
  }

  static fromJSON(json) {
    return new SegmentId(json);
  }
}
